module.exports = __webpack_public_path__ + "static/media/tick.c6ea1603.svg";